import { render } from "./StoreFooter.vue?vue&type=template&id=33188fc8&scoped=true"
import script from "./StoreFooter.vue?vue&type=script&lang=js"
export * from "./StoreFooter.vue?vue&type=script&lang=js"

import "./StoreFooter.vue?vue&type=style&index=0&id=33188fc8&scoped=true&lang=css"

import exportComponent from "E:\\GoWorkSpace2\\src\\storedisk\\storedisk\\storedisk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33188fc8"]])

export default __exports__